import { ListInfoBox, TabNavigation } from "@crunchyroll/cx-web-components";
import styles from "./CommentRestrictedVerifyEmail.module.scss"
import { FormattedMessage } from "react-intl";
import { useSendEmailVerification } from "../../user/emailVerification";

export const CommentRestrictedVerifyEmail = () => {
  const handleVerifyClick = useSendEmailVerification();

  return (
    <ListInfoBox
      className={styles.CommentRestrictedVerifyEmail}
      title={<FormattedMessage id="account_restricted.comment.title" />}
      description={
        <FormattedMessage
          id="account_restricted.description.verify_email"
          values={{
            "verify-email-cta": children =>
              <TabNavigation
                onClick={handleVerifyClick}
                className={styles.CommentRestrictedVerifyEmail__verifyEmail}
                as={"button"}
              >
                {children}
              </TabNavigation>
          }}
        />
      }
    />
  )
}